/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ExternalDocumentSubTypeDto } from '../../models/external-document-sub-type-dto';

export interface GetDocumentSubTypesByCustomerAndType$Params {
  typeId: number;
  customerGUID: string;
}

export function getDocumentSubTypesByCustomerAndType(http: HttpClient, rootUrl: string, params: GetDocumentSubTypesByCustomerAndType$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ExternalDocumentSubTypeDto>>> {
  const rb = new RequestBuilder(rootUrl, getDocumentSubTypesByCustomerAndType.PATH, 'get');
  if (params) {
    rb.path('typeId', params.typeId, {});
    rb.path('customerGUID', params.customerGUID, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ExternalDocumentSubTypeDto>>;
    })
  );
}

getDocumentSubTypesByCustomerAndType.PATH = '/external-document/types/{typeId}/sub-type/customers/{customerGUID}';
